module.exports = __webpack_public_path__ + "51986bfc4e0f5ad2b68235a6336e6ec1.png";